import React from 'react'
import { Image } from 'react-native'

import { B4, Icon } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LinearGradient } from 'expo-linear-gradient'

const BrandCardTag = ({
  className,
  topBarColors,
  topBarText,
  topBarIcon,
  tagType,
  iconStyle,
  iconType,
}: {
  title?: string
  className?: string
  topBarColors?: string
  topBarText?: string
  topBarIcon?: string
  iconType?: string
  iconStyle?: string
  tagType?: 'onHold' | 'preApproved'
}) => {
  const TAG_DETAILS = {
    onHold: {
      iconType: 'Stop',
      title: 'brandCard.topTag.onHold',
      gradientColors: ['#1C2738', '#1C2738'],
    },
    preApproved: {
      iconType: 'Star',
      title: 'brandCard.topTag.preApproved',
      gradientColors: ['#DF75FA', '#CC3DF1', '#CC3DF1', '#DF75FA'],
    },
  }
  return (
    <LinearGradient
      colors={
        tagType
          ? TAG_DETAILS?.[tagType]?.gradientColors
          : topBarColors
          ? JSON.parse(topBarColors)
          : ['#fff', '#fff']
      }
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      className={`w-full flex-row items-center justify-center p-0.5 ${className}`}
    >
      {tagType ? (
        <Icon
          className={iconStyle}
          type={iconType || (tagType && TAG_DETAILS[tagType]?.iconType) || ''}
          color="white"
        />
      ) : (
        topBarIcon && (
          <Image
            source={{ uri: topBarIcon }}
            resizeMode="contain"
            style={{ width: 20, height: 20 }}
          />
        )
      )}

      {tagType ? (
        <B4 className="ml-2 text-white">
          {i18n.t(TAG_DETAILS?.[tagType]?.title)}
        </B4>
      ) : (
        topBarText && <B4 className="ml-2 text-white">{topBarText}</B4>
      )}
    </LinearGradient>
  )
}

export default BrandCardTag
